import React from 'react';
import { Stepper, StepperItem, useBreakpoints } from '@honeycomb/ui-core';
import { FeatureFlagEnum, TripType, hasFeatureFlag, useGlobalContext } from '@honeycomb/data';
import { FunnelStep, getHolidayFunnelStepperRoute } from '@honeycomb/routing';
import { StepperBookingItems } from './StepperBookingItems';
import { parseBoolean } from '../../utils/string-utils';
export function HotelFunnelStepper(props) {
    const { resourceStrings: { FUNNEL_BREADCRUMB_HOTEL, FUNNEL_BREADCRUMB_ROOMS, FUNNEL_BREADCRUMB_EXTRAS, FUNNEL_BREADCRUMB_BOOK, }, configSettings: { HCNewHotelExtraPage }, } = useGlobalContext();
    const { mediumUp } = useBreakpoints();
    const { funnelStep, queryString, estabId, hasMandatoryTransfer, hasHotelOptionalTransfer } = props;
    const tripType = TripType.Hotel;
    const routeToNewExtraPage = parseBoolean(HCNewHotelExtraPage) || hasFeatureFlag(FeatureFlagEnum.HOTEL_NEW_EXTRAS);
    const [selected, setSelected] = React.useState(funnelStep);
    const handleChange = (_event, value) => {
        setSelected(value);
    };
    const book = [FunnelStep.GuestInformation, FunnelStep.PaymentDetails].includes(funnelStep) ? (StepperBookingItems({
        queryString,
        funnelStep,
    })) : (React.createElement(StepperItem, { label: FUNNEL_BREADCRUMB_BOOK, value: FunnelStep.Book, "data-id": `hotel-funnel-stepper-${funnelStep === FunnelStep.GuestInformation ? 'guestInformation' : 'PaymentDetails'}` }));
    return mediumUp ? (React.createElement(Stepper, { onChange: handleChange, value: selected, "data-id": "hotel-funnel-stepper" },
        React.createElement(StepperItem, { completed: funnelStep > FunnelStep.ChooseHotel, interactive: funnelStep > FunnelStep.ChooseHotel, href: getHolidayFunnelStepperRoute({
                tripType,
                queryString,
                funnelStep: FunnelStep.ChooseHotel,
            }) || undefined, value: FunnelStep.ChooseHotel, label: FUNNEL_BREADCRUMB_HOTEL, "data-id": "hotel-funnel-stepper-hotel" }),
        React.createElement(StepperItem, { href: getHolidayFunnelStepperRoute({
                tripType,
                estabId,
                funnelStep: FunnelStep.ChooseRoom,
                queryString,
            }) || undefined, completed: funnelStep > FunnelStep.ChooseRoom, interactive: funnelStep > FunnelStep.ChooseRoom, value: FunnelStep.ChooseRoom, label: FUNNEL_BREADCRUMB_ROOMS, "data-id": "hotel-funnel-stepper-room" }),
        (hasMandatoryTransfer || hasHotelOptionalTransfer) && (React.createElement(StepperItem, { href: getHolidayFunnelStepperRoute({
                tripType,
                hasMandatoryTransfer,
                funnelStep: FunnelStep.CustomiseTripHotel,
                queryString,
                routeToNewExtraPage,
            }) || undefined, completed: funnelStep > FunnelStep.CustomiseTrip, interactive: funnelStep > FunnelStep.CustomiseTrip, value: FunnelStep.CustomiseTrip, label: FUNNEL_BREADCRUMB_EXTRAS, "data-id": "hotel-funnel-stepper-extras" })),
        book)) : (React.createElement(Stepper, { numberSteps: true, onChange: handleChange, value: selected, justifyContent: "center", "data-id": "hotel-funnel-stepper" }, book));
}
